"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Dashboard.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Dashboard = function Dashboard(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 257.04 242.67"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Dashboard Icon"), _react2.default.createElement("g", {
    className: "dashboard",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M174.29 242.67H82.75a47.62 47.62 0 0 1-27.12-8.44A128.49 128.49 0 0 1 123.59 0h9.86a128.49 128.49 0 0 1 68 234.21 47.6 47.6 0 0 1-27.16 8.46zM124.2 20A108.49 108.49 0 0 0 67 217.76a27.7 27.7 0 0 0 15.78 4.91h91.54a27.69 27.69 0 0 0 15.78-4.91A108.49 108.49 0 0 0 132.86 20h-8.66z",
    className: "dash",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M53.3 151.35H37.81a10 10 0 0 1 0-20H53.3a10 10 0 0 1 0 20zm164.1 0h-15.49a10 10 0 1 1 0-20h15.49a10 10 0 0 1 0 20zM128.52 64a10 10 0 0 1-10-10V38.54a10 10 0 1 1 20 0V54a10 10 0 0 1-10 10zM67.5 97.78a10 10 0 0 1-6.41-2.33l-11.88-9.93A10 10 0 1 1 62 70.17l11.92 9.93a10 10 0 0 1-6.42 17.68zm120.21 0a10 10 0 0 1-6.42-17.67l11.89-9.93A10 10 0 0 1 206 85.52l-11.89 9.93a10 10 0 0 1-6.4 2.33z",
    className: "markers",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "pointer",
    d: "M114.65 149.89L87.31 98.21 138 126.56a17 17 0 1 1-17.42 29.26 17.24 17.24 0 0 1-5.93-5.93z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: undefined
  })));
};
exports.default = Dashboard;